'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBemReact = require('@yandex-lego/i-bem-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBemReact.decl)({
    block: 'popup2',
    elem: 'tail',
    attrs: function attrs(_ref) {
        var style = _ref.style;
        var _context = this.context,
            tailStyles = _context.tailStyles,
            setTailRef = _context.setTailRef;

        var styles = Object.keys(style) > 0 ? style : tailStyles;

        return {
            style: styles,
            ref: setTailRef
        };
    },
    content: function content(_ref2) {
        var children = _ref2.children;

        return children;
    }
}, {
    propTypes: {
        style: _propTypes2.default.object
    },
    defaultProps: {
        style: {}
    },
    contextTypes: {
        tailStyles: _propTypes2.default.object.isRequired,
        setTailRef: _propTypes2.default.func.isRequired
    }
});